/**
 * Supabase Browser Client
 * Use in Client Components only. Uses the public anon key — subject to RLS.
 *
 * A generated `Database` type is exported from `@novixone/shared`
 * for callers who want schema-drift safety at compile time — cast the
 * returned client with `as SupabaseClient<Database>`. Whole-app typed
 * migration is tracked separately (see comments in ./server.ts).
 */
import { createBrowserClient } from '@supabase/ssr'

export function createSupabaseClient() {
  return createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!
  )
}
